import React from 'react'
import { BtnV2, BtnV2Props, IconNames, l, useRefCallback } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { billing } from 'common/billing/billingService/billingService'
import { TRIAL_PERIOD_IN_DAYS } from 'common/billing/constants'
import { SubscriptionAction } from 'common/billing/constants/SubscriptionAction'
import { getSubscriptionAction } from 'common/billing/entities/subscription/selectors'
import {
  getIsEnableNewCtaOnBar,
  getUpgradeCaption,
} from 'common/billing/entities/upgradeRequest/selectors'
import { RequestUpgradePayload } from 'common/billing/interfaces/requestUpgradePayload'
import { analyticsService } from 'utils/services/analytics'

export type GoProBtnProps = {
  forceShow?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  label?: string
  forceLabel?: boolean
  onUpgrade?: (value: boolean) => void
  request: RequestUpgradePayload
  isSidebarHidden?: boolean
} & BtnV2Props

const GoProBtn = ({
  label: labelProp = l.translate('Upgrade to Pro'),
  forceLabel,
  onClick,
  forceShow = false,
  isSidebarHidden,
  request,
  onUpgrade,
  ...other
}: GoProBtnProps) => {
  const defaultLabel = useAppSelector(getUpgradeCaption)
  const label = forceLabel ? labelProp : defaultLabel
  const subscriptionAction = useAppSelector(getSubscriptionAction)
  const isEnableNewCtaOnBar = useAppSelector(getIsEnableNewCtaOnBar)

  const openUpgradeToPro = useRefCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    analyticsService.sendEvent('SESSION_QUALITY.CLICK.UPGRADE1', {
      subscriptionAction,
    })

    billing.requestUpgrade(request).then(onUpgrade)
  })

  if (subscriptionAction === SubscriptionAction.NONE && !forceShow) {
    return null
  }

  const iconByAction: Partial<Record<SubscriptionAction, IconNames>> = {
    [SubscriptionAction.ACTIVATE_TRIAL]: 'MagicWand',
    [SubscriptionAction.RENEW]: 'Renew',
  }
  const icon = iconByAction[subscriptionAction]

  if (isEnableNewCtaOnBar && icon) {
    const trialLabel =
      subscriptionAction === SubscriptionAction.ACTIVATE_TRIAL
        ? l.translate('Try {daysCount} days for Free', { daysCount: TRIAL_PERIOD_IN_DAYS })
        : label

    if (isSidebarHidden) {
      return <BtnV2 {...other} onlyIcon={icon} ariaLabel={trialLabel} onClick={openUpgradeToPro} />
    }

    return <BtnV2 {...other} label={trialLabel} leftIcon={icon} onClick={openUpgradeToPro} />
  }

  return <BtnV2 {...other} label={label} onClick={openUpgradeToPro} />
}

export default GoProBtn
